import httpUtils from '../../utils/HttpUtils'

class TradeEvaluateService {

  //获取店铺列表信息
  async list(shopId = '', pageNo = 1) {
    let result = null;
    try {
      result = await httpUtils.post('/mall/trade/evaluate/list', {shopId, pageNo})
    } catch (error) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'};
    }
    return result
  }
}
export default new TradeEvaluateService()
